import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValFormReg } from "../../../Validators/ValForms";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import request from "../../../Helpers/API";
import { TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import InfoIcon from "@mui/icons-material/Info";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";


export const ValidarFactura = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  idproceso = 24,
  upload,
  // Inyectado por ModalSolicitudCreditoJDF (ver ModalSCScreens). Habilita
  // "Siguiente" tras aceptar, sin cerrar el modal.
  habilitarSiguiente,
}) => {
  const [comentarios, setComentarios] = useState("");
  const [estatus, setEstatus] = useState({});




  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: idproceso,
      responsable: "J",
    };
    request
      .post(`ACAnalisisDecicion`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onEnviarComentario = (estado) => {
    // const rescomentarios = ValFormReg(
    //   "Comentarios",
    //   comentarios,
    //   RegularExpressions.TextSpecialCharacter,
    //   15,
    //   2000
    // );
    // if (rescomentarios.isValid === false) {
    //   Swal.fire(
    //     "ANALISIS DE SOLICITUD DE CREDITO",
    //     rescomentarios.mensaje,
    //     "error"
    //   );
    //   return;
    // }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: idproceso,
      consecutivo: -1,
      comentarios:
        comentarios.length === 0 && estado === "A"
          ? "DATOS DE FACTURACION VALIDADOS"
          : comentarios,
      estatus: estado,
    };
    request
      .post("ACTimeLineComentarios/GuardarComentario", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);

        setComentarios("");
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();
        if (estado === "M") {
          upload()
        }

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (
          estado === "A" &&
          habilitarSiguiente !== undefined &&
          habilitarSiguiente !== null
        )
          habilitarSiguiente();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumentoValidacionF?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        // const linkSource = result.comentarios;
        // const downloadLink = document.createElement("a");
        // const fileName = `${result.documento}.${result.extension}`;
        // downloadLink.href = linkSource;
        // downloadLink.download = fileName;
        // downloadLink.click();
        if (result.length > 0) {
          result.forEach((documento, index) => {
            const linkSource = `${documento.documento}`;
            const downloadLink = document.createElement("a");
            const fileExtension = documento.extension;

            // Define el nombre del archivo basado en el iddocumento
            let fileName;
            if (documento.iddocumento === 71) {
              fileName = `Factura-${index + 1}.${fileExtension}`;
            } else if (documento.iddocumento === 78) {
              fileName = `Nota de abono-${index + 1}.${fileExtension}`;
            } else {
              fileName = `Documento-${index + 1}.${fileExtension}`;
            }

            // Configura el enlace para la descarga
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          Swal.fire("Clientes", "No se encontraron documentos para descargar", "info");
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };
  return (
    <div className="analisis-credito-modal-comentarios-jdf">
      <div className="analisis-credito-modal-comentarios-jdf-content">
        <div className="analisis-credito-modal-comentarios-jdf-content-title">
          <InfoIcon className="icon-info" /> TIEMPO DE RESPUESTA ESTIMADO:{" "}
          {estatus.tiempoestimado}
        </div>
        <div className="analisis-credito-modal-jdf-content-comentarios">
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <></>
          ) : (
            <>
              <div
                className="analisis-credito-modal-pedido-content-pdf"
                onClick={() => onImprimirArchivo(71)}
              >
                <CloudDownloadIcon />
                <div>DESCARGAR FACTURA</div>
              </div>
              <div
                className="analisis-credito-modal-pedido-content-pdf"
                onClick={() => onImprimirArchivo(78)}
              >
                <CloudDownloadIcon />
                <div>DESCARGAR NOTA DE ABONO</div>
              </div>
              <TextField
                fullWidth
                size="small"
                label="COMENTARIOS"
                className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                multiline
                rows={4}
                type="text"
                // error={condiciones.bcondiciones}
                onChange={({ target }) => {
                  ValSpecialCharacters(
                    "condiciones",
                    target.value,
                    onChange,
                    true,
                    500
                  );
                }}
                value={comentarios}
              />
              <div className="analisis-credito-modal-jdf-content-buttons">
                <div
                  className="analisis-credito-modal-pedido-content-refacturacion-button"
                  onClick={() => {
                    onEnviarComentario("M");
                  }}
                >
                  <CancelIcon />
                  <div>SOLICITAR REFACTURACION</div>
                </div>
                <div
                  className="analisis-credito-modal-pedido-content-aceptar-facturacion-button"
                  onClick={() => {
                    onEnviarComentario("A");
                  }}
                >
                  <CheckCircleIcon />
                  <div>ACEPTAR</div>
                </div>
              </div>
            </>
          )}
        </div>
        {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          (estatus.habilitar === false && (
            <>
              <div
                className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
              >
                <label>Comentarios</label>
                <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                  <OnGetIcon icon={estatus.icono} />
                </div>
                <div className="analisis-credito-modal-pedido-content-comentarios-div">
                  {estatus.comentarios}
                </div>
              </div>
              <div
                className="analisis-credito-modal-pedido-content-pdf"
                onClick={() => onImprimirArchivo(71)}
              >
                <CloudDownloadIcon />
                <div>DESCARGAR FACTURA</div>
              </div>
              <div
                className="analisis-credito-modal-pedido-content-pdf"
                onClick={() => onImprimirArchivo(78)}
              >
                <CloudDownloadIcon />
                <div>DESCARGAR NOTA DE ABONO</div>
              </div>
            </>
          ))}
      </div>
      <div className="analisis-credito-modal-pedido-footer"></div>
    </div>
  );
};
